module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-four3.c4aa75f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-four3.png
// module id = f2rC
// module chunks = 0